<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8 scyr-interior">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <section>
      <h1>Datos de correspondencia</h1>
      <p>Use el siguiente formulario para facilitarnos sus datos de correspondencia </p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Datos del solicitante</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>

            <div
              class="row"
              *ngIf="!contratoSelected.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionSuministro'"
                  [setLabel]="'Dirección suministro'"
                  [setValue]="direccionSuministro"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="direccionSuministro = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'nombre'"
                  [setLabel]="'Nombre y apellidos'"
                  [setValue]="nombre"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="nombre = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'dni'"
                  [setName]="'dni'"
                  [setLabel]="'DNI'"
                  [setValue]="dni"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="dni = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'email'"
                  [setLabel]="'Email'"
                  [setValue]="email"
                  [setReadOnly]="true"
                  (outValue)="email = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'tel'"
                  [setName]="'telefono'"
                  [setLabel]="'Teléfono'"
                  [setValue]="telefono"
                  [setReadOnly]="true"
                  (outValue)="telefono = $event"
                ></sacyr-input>
              </div>
            </div>
          </fieldset>
          <h2 class="line">Datos domicilio de Correspondencia</h2>
          <fieldset>
            <legend class="sr-only">Formulario correspondencia</legend>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'nombreCorrespondencia'"
                  [setLabel]="'Nombre y apellidos'"
                  [setValue]="nombreCorrespondencia"
                  [setRequired]="true"
                  [setError]="nombreCorrespondenciaInputError ? 'Introduzca una nombre válido' : ''"
                  (outValue)="nombreCorrespondencia = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionCorrespondencia'"
                  [setLabel]="'Dirección'"
                  [setValue]="direccionCorrespondencia"
                  [setRequired]="true"
                  [setError]="direccionCorrespondenciaInputError ? 'Introduzca una dirección válida' : ''"
                  (outValue)="direccionCorrespondencia = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label
                    for="pais"
                    class="slct"
                  >País</label>
                  <div class="select">
                    <select
                      name="paisCorrespondencia"
                      [value]="paisCorrespondencia"
                      [(ngModel)]="paisCorrespondencia"
                      required
                    >
                      <option
                        *ngFor="let country of paises"
                        [value]="country.value"
                        [disabled]="country.disabled"
                      >{{country.text}}</option>
                    </select>
                  </div>
                </div>
                <span
                  *ngIf="paisCorrespondenciaInputError == true"
                  class="error"
                >Seleccione un país</span>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'provinciaCorrespondencia'"
                  [setLabel]="'Provincia'"
                  [setValue]="provinciaCorrespondencia"
                  [setRequired]="true"
                  [setError]="provinciaCorrespondenciaInputError ? 'Introduzca una provincia válida' : ''"
                  (outValue)="provinciaCorrespondencia = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'poblacionCorrespondencia'"
                  [setLabel]="'Población'"
                  [setValue]="poblacionCorrespondencia"
                  [setRequired]="true"
                  [setError]="poblacionCorrespondenciaInputError ? 'Introduzca una población válida' : ''"
                  (outValue)="poblacionCorrespondencia = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'codigoPostalCorrespondencia'"
                  [setLabel]="'Código Postal'"
                  [setValue]="codigoPostalCorrespondencia"
                  [setRequired]="true"
                  [setError]="codigoPostalCorrespondenciaInputError ? 'Introduzca un código postal válida' : ''"
                  (outValue)="codigoPostalCorrespondencia = $event"
                ></sacyr-input>
              </div>

            </div>
          </fieldset>
        </form>
      </div>
    </section>
    <div
      class="input-form input-button"
      *ngIf="!contratoSelected.Ficticio"
    >
      <button
        (click)="actualizarDatosCorrespondencia()"
        type="submit"
        class="btn-default"
        value=""
      >Enviar</button>
    </div>
  </div>
